import { Switch, Match } from "solid-js";
import type { MainProps } from "./_model";
import { SideNav } from ":setup/qrouter";
import { global } from ":shared/app";
import { solidstate } from ":setup/qstate";

//
import "./style/nav-side.css";

export default function DashboardLayout(props: MainProps) {
  const $breakpoint = global.store.hooks.dom.useBreakpoints();
  const $show_sidenav = solidstate.create(false);
  global.store.triggers.route.onNavigated(() => {
    if ($show_sidenav.value) {
      $show_sidenav.set(false);
    }
  });

  return (
    <main class={`flex flex-col w-full h-full space-y-2`}>
      <Switch fallback="awaiting breakpoint layout...">
        {/* phone view */}
        <Match when={$breakpoint()?.misc.lg.widthIsLess}>
          <section class="relative flex flex-col !z-1 w-full h-full">
            {props.childrenTop}
            {/* burger area */}
            <div class="relative flex flex-row w-full h-2.5rem bg-bg px-2 items-center justify-end !z-100">
              {/* idle */}
              <div
                class={
                  "flex flex-row w-full h-full justify-between items-center transition transition-all duration-300 ease-in-out !z-100 overflow-hidden" +
                  " " +
                  ($show_sidenav.value ? "hidden" : "")
                }
                onclick={() => $show_sidenav.set((s) => !s)}
              >
                <i class="i-stash:burger-classic w-1rem h-1rem text-brand mt-1" />
                <img class="w-4rem h-full !z-99 mt-2" src="/logo.svg" alt="logo" />
              </div>
              {/* bg shade */}
              <div
                class={`fixed top-0 left-0 bg-bg-shade min-w-full w-full h-full
                      ${$show_sidenav.value ? "" : "hidden"}`}
              />
              {/* slided */}
              <div
                class={`
                  fixed top-0 -left-100% grid grid-cols-[80%_20%] w-full h-full !z-100 !overflow-hidden
                  transition transition-all duration-300 ease-in-out 
                  ${$show_sidenav.value ? "!left-0" : ""}
                  `}
              >
                {/* the menu itself */}
                <div class="grid grid-rows-[95px_1fr] w-full h-full bg-bg text-text pt-3 gap-1.5 scrollbar overflow-hidden">
                  <div class="flex flex-col w-full h-auto items-center justfify-center">
                    <img class="w-80% h-full bg-cover self-center" src="/logo.svg" alt="logo" />
                  </div>
                  <SideNav
                    {...props.sideNav}
                    triggers={{
                      ...props.sideNav?.triggers,
                      onClickedOutside: () => {
                        if ($show_sidenav.value) {
                          $show_sidenav.set(false);
                        }
                        props.sideNav?.triggers?.onClickedOutside?.();
                      },
                    }}
                    class={`nav-side ${props.sideNav.class ?? ""}`}
                  />
                </div>
                {/* close button */}
                <div class="flex flex-col w-24px h-24px rounded-full bg-bg mx-auto sm:(w-3.5rem h-3.5rem mt-4rem) <sm:(w-2rem h-2rem mt-2.5rem)">
                  <i class="i-lets-icons:close-ring-duotone w-full h-full text-brand " />
                </div>
              </div>
            </div>
            <div class="w-full max-w-full min-w-full h-full  !overflow-hidden bg-bg text-text !z-0">
              {props.children}
            </div>
          </section>
        </Match>
        {/* desktop/all-views view */}
        <Match when={true}>
          <section class="grid grid-cols-[12.5rem_1fr] w-full h-full !overflow-hidden">
            <div class="grid grid-rows-[150px_1fr] w-full h-full bg-bg text-text pt-4 gap-2 scrollbar overflow-hidden">
              <div class="flex flex-col w-full h-auto items-center justfify-center">
                <img class="w-87% h-full bg-cover self-center" src="/logo.svg" alt="logo" />
              </div>
              <SideNav {...props.sideNav} class={`nav-side ${props.sideNav.class ?? ""}`} />
            </div>
            {/* <div class="" /> */}
            <div class="flex flex-col w-full h-full bg-bg-alt !overflow-hidden">
              {props.childrenTop && (
                <div class="flex flex-col w-full min-h-100px h-100px max-h-100px overflow-hidden">
                  {props.childrenTop}
                </div>
              )}
              {/* !! don't do min-h-full ever, it prevent proper scroll view in very deep children !! */}
              <div class="flex flex-col w-full h-full px-4 py-4 !overflow-hidden ">
                <div class="flex flex-col w-full h-full bg-bg text-text rounded-2xl !overflow-hidden">
                  {props.children}
                </div>
              </div>
            </div>
          </section>
        </Match>
      </Switch>
    </main>
  );
}
